import { Button, Text } from "@/ui-kit"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/ui-kit/components/Dialog"

export type RestartVoteState = {
  activeRestartId: string | null
  hasVoted: boolean
  isRequester: boolean
  requiredVotes: number
  yesCount: number
  noCount: number
}

type RestartVoteDialogProps = {
  open: boolean
  restart: RestartVoteState
  restartPending: boolean
  onVoteRestart: (vote: boolean) => void
}

export function RestartVoteDialog({
  open,
  restart,
  restartPending,
  onVoteRestart,
}: RestartVoteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle className="!text-xl">Restart recording?</DialogTitle>
          <DialogDescription>
            {restart.isRequester
              ? "Waiting for other participants to vote..."
              : "The other participant wants to restart the recording."}
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center justify-center gap-2 py-2">
          <Text type="body2-regular" className="text-gray-80">
            {restart.yesCount}/{restart.requiredVotes} votes needed
          </Text>
        </div>
        <DialogFooter>
          {restart.isRequester || restart.hasVoted || restartPending ? (
            <Text type="body2-regular" className="text-gray-80">
              {restart.isRequester || restartPending
                ? "You requested this restart"
                : "Vote submitted"}
            </Text>
          ) : (
            <>
              <Button variant="bordered" onClick={() => onVoteRestart(false)}>
                Decline
              </Button>
              <Button variant="green" onClick={() => onVoteRestart(true)}>
                Agree
              </Button>
            </>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
